import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast'
import { FiChevronLeft } from 'react-icons/fi'
import SousCatégorieService from '../../service/SousCatégorieService'
import '../styles/AdminForm.css'

const FormSousCatégorie = () => {
  const navigate = useNavigate()
  const authorization = localStorage.getItem('token')
  const [infoac, setInfoac] = useState([])

  const [form, setForm] = useState({ name: '', type: '' })
  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/categorie/listerAll`).then((res) => {
      setInfoac(res.data)
    }).catch(() => {})
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm((f) => ({ ...f, [name]: value }))
    if (errors[name]) setErrors((err) => ({ ...err, [name]: null }))
  }

  const validate = () => {
    const err = {}
    if (!form.name.trim()) err.name = 'Le nom est requis'
    if (!form.type) err.type = 'Sélectionnez une catégorie'
    setErrors(err)
    return Object.keys(err).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validate()) {
      document.querySelector('.ata-error')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      return
    }

    const data = { name: form.name, type: form.type }

    setSubmitting(true)
    try {
      await SousCatégorieService.ajouter(data, authorization)
      toast.success('Sous-catégorie ajoutée avec succès')
      setTimeout(() => navigate('/admin/Sous-Catégorie'), 800)
    } catch (err) {
      toast.error("Échec de l'ajout")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="ata-page">
      <Toaster />

      <div className="ata-header">
        <button type="button" className="ata-back" onClick={() => navigate('/admin/Sous-Catégorie')}>
          <FiChevronLeft size={16} />
        </button>
        <div>
          <h1 className="ata-title">Ajouter une sous-catégorie</h1>
          <p className="ata-subtitle">Renseignez les informations de la nouvelle sous-catégorie</p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="ata-col-right" style={{ maxWidth: 640 }}>
          <div className="ata-card">
            <div className="ata-card__label">Informations générales</div>

            <div className="ata-field">
              <label>Nom *</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Ex: Canapé d'angle"
                className={errors.name ? 'ata-input--error' : ''}
              />
              {errors.name && <p className="ata-error">{errors.name}</p>}
            </div>

            <div className="ata-field">
              <label>Type *</label>
              <select
                name="type"
                value={form.type}
                onChange={handleChange}
                className={errors.type ? 'ata-input--error' : ''}
              >
                <option value="" hidden>Choisir une catégorie</option>
                {infoac.map((info) => (
                  <option key={info._id} value={info.name}>{info.name}</option>
                ))}
              </select>
              {errors.type && <p className="ata-error">{errors.type}</p>}
            </div>
          </div>
        </div>

        <div className="ata-footer-actions">
          <button type="button" className="ata-btn ata-btn--ghost" onClick={() => navigate('/admin/Sous-Catégorie')}>Annuler</button>
          <button type="submit" className="ata-btn ata-btn--primary" disabled={submitting}>
            {submitting ? (<><span className="ata-spinner" /> Enregistrement…</>) : 'Ajouter la sous-catégorie'}
          </button>
        </div>
      </form>
    </div>
  )
}

export default FormSousCatégorie
